import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash/fp';
import { useRouteMatch } from 'react-router-dom';
import { Container, Icon } from 'rsuite';
import { useDispatch, useSelector } from 'react-redux';
import {
  settingsPortalPantryPath,
  settingsPortalUsersPath,
  settingsPortalSmtpAccountPath
} from '../../../../routes/Paths';
import { toggleSidebarNav } from '../../../../redux/Settings/actions';
import * as PERMISSIONS from '../../../../constants/permissions/settings';
import { getSidebarNavExpanded } from '../../../../redux/Settings/selectors/components/page-layout';
import { hasViewAccess } from '../../../../helpers/permission';
import { getUserPermissionsAsMap } from '../../../../redux/selectors/permission';
import MainLayout from '../../../../containers/MainLayout';
import MainContent from '../../../MainContent';
import SidebarNav from '../../../SidebarNav';
import NavLink from '../../../NavLink';
import { NAV_KEYS, navKeysByPath } from './nav-keys';

const PageLayout = ({ children }) => {
  const dispatch = useDispatch();
  const { path } = useRouteMatch();
  const activeKey = get(path, navKeysByPath);
  const sidebarExpanded = useSelector(getSidebarNavExpanded);
  const permissions = useSelector(getUserPermissionsAsMap);

  const handleToggleSidebarNav = () => {
    dispatch(toggleSidebarNav());
  };

  return (
    <MainLayout>
      <MainContent>
        <SidebarNav
          activeKey={activeKey}
          expanded={sidebarExpanded}
          onToggle={handleToggleSidebarNav}
        >
          {hasViewAccess(PERMISSIONS.PORTAL, permissions) && (
            <NavLink
              to={settingsPortalPantryPath}
              eventKey={NAV_KEYS.PANTRY}
              icon={<Icon icon="window-maximize" />}
            >
              Pantry
            </NavLink>
          )}
          {hasViewAccess(PERMISSIONS.PORTAL, permissions) && (
            <NavLink
              to={settingsPortalUsersPath}
              eventKey={NAV_KEYS.USERS}
              icon={<Icon icon="user" />}
            >
              Guests
            </NavLink>
          )}
          {hasViewAccess(PERMISSIONS.SMTP, permissions) && (
            <NavLink
              to={settingsPortalSmtpAccountPath}
              eventKey={NAV_KEYS.SMTP_ACCOUNT}
              icon={<Icon icon="envelope" />}
            >
              SMTP Account
            </NavLink>
          )}
        </SidebarNav>
        <Container>{children}</Container>
      </MainContent>
    </MainLayout>
  );
};

PageLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default PageLayout;
